export default {
  title: {
    move: '移动到分组',
    add: '添加到分组',
    edit: '编辑分组',
    remove: '从分组移除'
  },
  label: {
    fromGroup: '从分组',
    toGroup: '到分组',
    comment: '评论',
    currentGroup: '当前分组',
    talentPoolGroup: '人才库分组',
    groupName: '分组',
    groupCandidateCount: '求职者数量',
    operation: '操作',
    selectGroup: '选择分组'
  },
  placeholder: {

  },
  btn: {
    toNewGroup: '到新分组',
    toExistedGroup: '到现有分组',
    addGroup: '添加',
    moveGroup: '移动',
    removeFromGroup: '移除',
    confirm: '确认',
    cancel: '取消'
  },
  message: {
    addGroupTip: '你可以选择添加至当前分组或者人才库分组',
    existedGroupName: '分组名称已存在，请输入其他名称',
    addGroupTalentPage: '你可以添加至选中分组也可从选中分组中移除也可移动进入别的分组',
    deleteGroupMessageTip: '确认删除分组吗? 此操作不可逆',
    deleteGroupMessageTitle: '提示',
    cancelDeleteGroup: '已取消删除'
  }
}
